/* tslint:disable */
/* eslint-disable */
export enum SortType {
  Asc = 'asc',
  Desc = 'desc'
}
